import { render } from "./ErrorComponent.vue?vue&type=template&id=f2e88992&ts=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__